/**
 * Widget Texte : un titre, sous-titre ou note pour organiser le dashboard
 * (ex. un titre de section « Bâtiments » posé au-dessus d'autres widgets).
 * Le fond peut être une carte ou transparent (titre de section qui « flotte »).
 */
import { WidgetShell } from "./WidgetShell";

export type TextWidgetProps = {
  text?: string;
  style?: "title" | "subtitle" | "body";
  align?: "left" | "center" | "right";
  background?: "card" | "transparent";
};

const STYLE_CLASS: Record<NonNullable<TextWidgetProps["style"]>, string> = {
  title: "text-lg font-oxaniumMedium text-default-text",
  subtitle:
    "text-sm font-oxaniumMedium uppercase tracking-wide text-grey-dark",
  body: "text-sm text-grey-dark",
};

const ALIGN_CLASS: Record<NonNullable<TextWidgetProps["align"]>, string> = {
  left: "text-left",
  center: "text-center",
  right: "text-right",
};

export const TextWidget = ({
  text = "",
  style = "title",
  align = "left",
  background = "card",
}: TextWidgetProps) => {
  return (
    <WidgetShell variant={background === "transparent" ? "bare" : "card"}>
      <div className="h-full flex items-center">
        <p
          className={`w-full break-words leading-tight ${STYLE_CLASS[style]} ${ALIGN_CLASS[align]}`}
        >
          {text || "Texte"}
        </p>
      </div>
    </WidgetShell>
  );
};
